<section
  edsSpacing="lg"
  edsPadding
  [edsPaddingLeft]="(isHandheld$ | async) ?'sm':'none'"
>
  <div edsGrid>
    <!-- breadcrumbs  area -->
    <eds-breadcrumbs
      [items]="breadcrumbs"
      theme="basic"
      actionsAriaLabel="Page Actions"
      edsPadding
      edsPaddingLeft="sm"
    >
    </eds-breadcrumbs>
    <div
      class="container"
      edsPadding
      [edsPaddingTop]="(isHandheld$ | async) ?'lg':'none'"
    >
      <!-- Your Cart -->
      <eds-title
        edsSpacing="xs"
        title="{{'literature.lit-order-history-title' | translate}}"
        size="h2"
        theme="basic"
        [isLight]="true"
        edsSpacing="xs"
      ></eds-title>
      <eds-title
        title="{{'literature.lit-order-history-description' | translate}}"
        size="h6"
        theme="basic"
        [isLight]="true"
        [level]="3"
      ></eds-title>
    </div>
  </div>
</section>
